(function () {
    'use strict';

    angular.module('app')
        .factory('SalaMuseo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "sala-museo";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            },
            findByMuseoUrl: {
                method: 'GET',
                url: 'api/' + entidad + '/findByMuseoUrl',
                params: {
                    url: null
                },
                isArray: true
            }
        });
    }

})();
